import ajax from "@/common/ajax.js";

//获取专职人员列表
export function getStaff(record_id) {
  return ajax.request.get(`/api/staff?record_id=${record_id}`);
}

//提交人员信息
export function createMultiple(data) {
  return ajax.request.post("/api/staff/createMultiple", data);
}
